import React, { useState } from 'react';
import { Button, useRecordContext } from 'react-admin';
import sacopModules from '../../utilities/sacopModules';
import CircularProgress from '@mui/material/CircularProgress';

const isActionButtonDisabled = (record: any, action: string) => {
    switch (action) {
        case sacopModules.REQUESTFORACTION:
            return record.sendToResponsibleForAnalysis;
        case sacopModules.ANALYSISFORSHARES:
            return record.sendToResponsibleForImplementation;
        case sacopModules.IMPLEMENTATIONFORACTION:
            return record.sendToResponsibleForClosingOfActions;
        case sacopModules.CLOSINGFORSHARES:
            return Boolean(record.sendToResponsibleForVerificationEffectivenessAction);
        default:
            return false;
    }
}

const CustomButton = ({ title, icon, onClick, action }) => {
    const record = useRecordContext();
    const [loading, setLoading] = useState(false);

    if (!record) {
        return null;
    }

    const isDisabled = isActionButtonDisabled(record, action);

    const handleClick = async (e: React.MouseEvent) => {
        e.stopPropagation();
        setLoading(true);
        try {
            await onClick(record);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button 
            key={record.id} 
            label={title} 
            disabled={isDisabled || loading} 
            onClick={handleClick}
        >
            {loading ? <CircularProgress size={16} sx={{ marginRight: 1 }} /> : icon}
        </Button>
    );
};

export default CustomButton;